"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = {
  root: function root(_ref) {
    var inactive = _ref.inactive;
    return _extends({
      boxShadow: '0 0 20px 0 rgba(0,0,0,0.12)',
      transition: '0.3s'
    }, !inactive && {
      '&:hover': {
        transform: 'translateY(-3px)',
        boxShadow: '0 4px 20px 0 rgba(0,0,0,0.12)'
      }
    });
  }
};
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@mui-treasury/styles/shadow/softRise/softRiseShadow.styles.js
// module id = 945
// module chunks = 0